<template>
  <div class="g-bottom">
    <div class="g-bottom-content">
      <div class="content-l">
        <img style="width:142px;height:auto;margin-left:-31px;" src="@assets/img/icmef.png" />
        <div>
          <span @click="goOnline">线上推广</span>
          <span @click="goVisit">参观展会</span>
          <span @click="goMeeting">会议论坛</span>
        </div>
      </div>
      <div class="content-c">
        <p style="font-weight: bold;">官方平台</p>
        <div>
          <Poptip trigger="hover" placement="top" style="width:30px;margin-right:30px;position:relative;">
            <i style="margin: 0 40px 0 0;" class="icon iconfont icon-weixin2"></i>
            <div slot="content">
              <img style="width:116px;height:116px;border-radius:5px;" src="@assets/img/cmef-wx.png" />
            </div>
          </Poptip>
          <Poptip trigger="hover" placement="top" style="width:30px;position:relative;margin-right:30px;" popper-class="pop-ly">
            <i style="color:#2475ca;" class="icon iconfont icon-lingying"></i>
            <div slot="content">
              <img style="width:106px;height:105px;border-radius:5px;" src="@assets/img/cmef-ly.png" />
            </div>
          </Poptip>
          <Poptip trigger="hover" placement="top" style="width:30px;position:relative;" popper-class="pop-ly">
            <i style="color:#06c140; " class="icon iconfont icon-xiaochengxu">

            </i>
            <div slot="content">
              <img style="width:106px;height:105px;border-radius:5px;" src="@assets/img/wx-weapp.png" />
            </div>
          </Poptip>
        </div>
      </div>
      <div class="logo">
        <img @click="lineTo1" src="./img/rse.png" />
        <img @click="lineTo2" src="./img/cmef.png" />
        <img @click="lineTo3" src="./img/recovery.png" />
        <img @click="lineTo4" src="./img/icmd.png" />
        <img @click="lineTo5" style="margin-right:0;" src="./img/wisdom.png" />
      </div>
    </div>
    <p class="copyright">版权所有 &copy; {{new Date().getFullYear()}} 国药励展展览有限责任公司
      <a style="color:#024c8b;" href="http://beian.miit.gov.cn/" target="_blank">备案序号：京ICP备06050757号-7</a>
      &nbsp;&nbsp;&nbsp;互联网药品信息服务资格证书 证书编号: (京)-经营 性-2020-0007
    </p>
  </div>
</template>

<script>
import config from "@assets/config.json";
export default {
  name: "g-bottom",
  methods: {
    lineTo1() {
      window.open('http://www.reed-sinopharm.com/','_blank');
    },
    lineTo2() {
      window.open('https://www.cmef.com.cn/','_blank');
    },
    lineTo3() {
      window.open('http://www.rehabshow.com.cn/','_blank');
    },
    lineTo4() {
      window.open('http://www.icmd.com.cn','_blank');
    },
      lineTo5 () {
        return
      window.open(`https://www.cmef.com.cn/g1180.aspx`,'_blank');
    },
    goOnline() {
      window.open(`https://synairsoft.obs.cn-north-4.myhuaweicloud.com/2024/0/9cf6eabc-6cf8-488c-8c86-8304d8a69c7c.pdf`,'_blank');
      
    },
    goVisit() {
    //   window.open('https://www.larspring.com/front/exhibitionregister/toExhibitionPage/23d7e4b773614d1780bc6670ade88cf2?sid=f22da08f462d405f8a309ae0e6d26d8c','_blank');
      window.open('https://reg.reed-sinopharm.com/pc/#/login?id=72324ec62ebf4875841b42b6c75b6b21&channelUuid=73614a0670da437e89774b5019208825','_blank');

    },
    goMeeting() {
    //   window.open('https://live.cmef.com.cn/page/945270','_blank');
    window.open('https://www.cmef.com.cn/Conference?cid=19','_blank');

    }
  }
};
</script>

<style lang="scss" scoped>
.g-bottom {
  width: 100%;
  min-width: 1200px;
  height: 120px;
  background-color: #fff;
  border-top: 1px solid #175b94;
  &-content {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    .content-l {
      width: 240px;
      height: 100%;
      // padding-top: 25px;
      font-size: 12px;
      font-weight: bold;
      div {
        display: flex;
        justify-content: space-between;
        color: #024c8b;
        span {
          cursor: pointer;
        }
      }
    }
    .content-c {
      width: 250px;
      height: 100%;
      margin-left: 100px;
      padding-top: 25px;
      color: #024c8b;
      font-size: 12px;
      div {
        margin-top: 10px;
        color: #49BD38;
        display: flex;
        i {
          font-size: 30px;
          margin-right: 30px;
        }
      }
    }
    .logo {
      margin-top: 55px;
      img {
        margin-right: 31px;
        cursor: pointer;
      }
    }
  }
  .copyright {
    width: 100%;
    line-height: 54px;
    text-align: center;
    color: #024c8b;
    font-size: 12px;
    font-weight: bold;
    background: #fff;
  }
}
</style>
<style lang="scss">
.g-bottom {
  .ivu-poptip-popper {
    left: -45px !important;
    .ivu-poptip-inner {
      width: 120px;
      height: 120px;
    }
    .ivu-poptip-body {
      padding: 0 0 0 2px;
      div {
        margin-top: 5px;
      }
    }
    .ivu-poptip-arrow {
      margin-left: -22px;
    }
  }
  .pop-ly {
    .ivu-poptip-body {
      padding: 0 0 0 7px;
      div {
        margin-top: 8px;
      }
    }
  }
}
</style>
